/* Popup newsletter (ottobre 2026): compare dopo X secondi, si chiude con X o Esc e resta nascosto per N giorni. */
if (!customElements.get('newsletter-popup')) {
  class NewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.key;
      this.days = parseInt(this.dataset.days, 10) || 14;
      const delay = parseInt(this.dataset.delay, 10) || 0;
      const posted = /customer_posted=true/.test(location.search) || this.querySelector('.form-notification');

      this.querySelector('.nl-popup__close').addEventListener('click', () => this.close());
      this.onKey = (event) => {
        if (event.key === 'Escape') this.close();
      };

      if (this.dataset.editor === 'true') {
        document.addEventListener('shopify:section:select', (event) => {
          if (this.closest('.shopify-section') === event.target) this.open();
        });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (this.closest('.shopify-section') === event.target) this.hide();
        });
        return;
      }

      if (posted) {
        this.open();
        return;
      }
      if (this.isSnoozed()) return;
      this.timer = setTimeout(() => this.open(), delay);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('keydown', this.onKey);
    }

    isSnoozed() {
      try {
        const until = parseInt(localStorage.getItem(this.key), 10);
        return until && until > Date.now();
      } catch (e) {
        return false;
      }
    }

    open() {
      this.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-open')));
      document.addEventListener('keydown', this.onKey);
    }

    hide() {
      this.classList.remove('is-open');
      this.hidden = true;
      document.removeEventListener('keydown', this.onKey);
    }

    close() {
      this.hide();
      try {
        localStorage.setItem(this.key, String(Date.now() + this.days * 86400000));
      } catch (e) {}
    }
  }
  customElements.define('newsletter-popup', NewsletterPopup);
}
